import React, { Component } from "react";
import {Button, Card, Container} from "react-bootstrap";

export default class FollowingPlaceholder extends Component {

    render() {
        return (
            <Container>
                <div className="row gy-4">
                    <div className="col-12">
                        <Card>
                            <Card.Body>
                                <div className="card-text">
                                    <div className="row">
                                        <div className="col-sm-4 text-truncate">
                                            <div className="d-flex">
                                                <div className="p-2">
                                                    <div className="p-relative placeholder-glow">
                                                        <div className="rounded-circle border align-items-center avatar text-start placeholder"></div>
                                                    </div>
                                                </div>
                                                <div className="p-2 text-truncate placeholder-glow">
                                                    <h6 className="name text-truncate placeholder-glow "><span className="placeholder col-7"></span></h6>
                                                    <p className="username text-muted text-truncate"> 
                                                        <span className="placeholder width-200"/>
                                                    </p>
                                                    <p className="text-truncate note text-muted">
                                                        <span className="placeholder col-2"/> &nbsp;
                                                        <span className="placeholder col-6"/> &nbsp;
                                                        <span className="placeholder col-3"/>
                                                    </p>                                                            
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-sm-2 d-flex justify-content-center placeholder-glow">
                                            <div className="d-flex justify-content-center">
                                                <div className="p-2 align-self-center text-center">
                                                <div className="rounded-circle border align-items-center placeholder-circle text-start placeholder"></div><br/>
                                                    <span className="confident-text"><span className="placeholder width-75"/> </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 text-truncate">
                                            <div className="d-flex">
                                                <div className="p-2">
                                                    <div className="p-relative placeholder-glow">
                                                        <div className="rounded-circle border align-items-center avatar text-start placeholder"></div>
                                                    </div>
                                                </div>
                                                <div className="p-2 text-truncate placeholder-glow">
                                                    <h6 className="name text-truncate placeholder-glow "><span className="placeholder col-7"></span></h6>
                                                    <p className="username text-muted text-truncate"> 
                                                        <span className="placeholder width-200"/>
                                                    </p>
                                                    <p className="text-truncate note text-muted">
                                                        <span className="placeholder col-2"/> &nbsp;
                                                        <span className="placeholder col-6"/> &nbsp;
                                                        <span className="placeholder col-3"/>
                                                    </p>                                                            
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-sm-2 placeholder-glow">
                                            <div className="d-flex justify-content-center">
                                                <div className="p-2 align-self-center">
                                                    <Button className="btn btn-primary disabled placeholder col-6 width-93"> </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </Container>
        );
    }
}
